import { apiPutNoContent } from "./http";

/** 已登录平台运营端（Bearer）时修改 `/platform/login` 所用口令。 */
export async function putPlatformAdminPassword(oldPassword: string, newPassword: string): Promise<void> {
  await apiPutNoContent("/api/platform/password", { oldPassword, newPassword });
}
